/* unplugin-vue-components disabled */import { render } from "./w-select-advanced.vue?vue&type=template&id=1b854b3f&scoped=true&ts=true"
import script from "./w-select-advanced.vue?vue&type=script&lang=ts"
export * from "./w-select-advanced.vue?vue&type=script&lang=ts"

import "./w-select-advanced.vue?vue&type=style&index=0&id=1b854b3f&scoped=true&lang=scss"
import "./w-select-advanced.vue?vue&type=style&index=1&id=1b854b3f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b854b3f"]])

export default __exports__